import { Pharmacy } from "~/common/types/pharmacies";

export const formatPharmacyToString = (pharmacy: Pharmacy) => {
  const { city, state, street } = pharmacy.address;
  const { phone_number, name } = pharmacy;

  return `${name} - ${street} ${city} ${state} ${phone_number}`;
};
